var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{staticClass:"cls-1",attrs:{"d":"M719.007,660A9.007,9.007,0,1,1,710,669.007,9.006,9.006,0,0,1,719.007,660Zm-0.017,1.994a7,7,0,1,1-7,7A7,7,0,0,1,718.99,661.994Zm-5,6h10.019v2H713.986v-2Zm10.553,4.872,5.446,5.086a2.166,2.166,0,0,1-.237,1.592,2.956,2.956,0,0,1-1.7.328l-5.237-5.191Z","transform":"translate(-710 -660)"}})
}
var staticRenderFns = []

export { render, staticRenderFns }